import { UserContext } from 'components/AuthProvider/UserProvider';
import { useContext } from 'react';

export default function useCurrentUser() {
  const { currentUser, floating, setInviteModal, setUpgradeModal } = useContext(UserContext);
  return { currentUser, floating, setInviteModal, setUpgradeModal };
}
